<template>
	<div class="socials" :class="theme">
		<a v-for="medium in socials" :key="medium.ID" :class="medium.platform" :href="medium.url" target="_blank">
			<div v-if="medium.platform == 'instagram'" class="social-instagram" :title="medium.platform" />
			<img v-else-if="medium.platform == 'facebook'" src="~/assets/images/Facebook.svg" alt="medium.platform" />
			<img v-else-if="medium.platform == 'youtube'" src="~/assets/images/Youtube.svg" alt="medium.platform" />
			<img v-else-if="medium.platform == 'pinterest'" src="~/assets/images/Pinterest.svg" alt="medium.platform" />
			<font-awesome-icon v-else :icon="`fa-brands fa-${medium.platform}`" size="1x" />
		</a>
	</div>
</template>

<script setup>
defineProps({
	theme: { type: String, default: 'dark' },
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials .tripadvisor {
	background: url('~/assets/images/tripadvisor-small-white.png') no-repeat center center;
	background-size: 22px;
	width: 50px;
	height: 50px;
	line-height: 50px;
}

.socials {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	justify-content: flex-start;
	gap: 30px;

	a {
		text-align: center;
		font-size: 24px;
		text-decoration: none;
		color: #fff;
		display: inline-block;
		border-radius: 50%;

		&:hover {
			border-color: #fff;
			color: #000;
		}

		.social-instagram {
			background: url('~/assets/images/Instagram.png') no-repeat center center;
			width: 20px;
			height: 20px;
			background-size: 20px;
			transition: all 0.3s ease-in-out;

			&:hover {
				background: url('~/assets/images/Instagram-hover.png') no-repeat center center;
				background-size: 20px;
			}
		}
	}

	svg {
		width: 20px;
		height: 20px;
	}

	&.light a {
		color: $primary-text-color;
		border-color: #ccc;

		&:hover {
			border-color: #999;
		}
	}
}
</style>
